import { useEffect, useState } from 'react'
import { onUploadState } from '../../services/uploads'

/**
 * A thin bar at the top of the window whenever anything is uploading, anywhere in the app.
 *
 * An upload with no feedback is indistinguishable from a hang, and the reasonable thing to do
 * about a hang is to refresh — which is how a consultant lost twenty minutes of signup. This
 * says "it is moving, and here is how far", so waiting is an informed choice rather than a
 * guess.
 *
 * Mounted once, fed by the shared clients, so a form does not have to remember to show it.
 */
export default function UploadIndicator() {
  const [{ active, percent }, setState] = useState({ active: 0, percent: 0 })

  useEffect(() => onUploadState(setState), [])

  if (!active) return null

  return (
    <div className="fixed top-0 left-0 right-0 z-[9999] pointer-events-none">
      <div className="h-1 bg-blue-100">
        <div
          className="h-1 bg-blue-600 transition-[width] duration-200 ease-out"
          style={{ width: `${Math.max(3, percent)}%` }}
        />
      </div>
      <div className="flex justify-center">
        <span className="mt-1 px-3 py-1 rounded-full bg-gray-900/85 text-white text-[11px] font-medium shadow">
          {percent >= 99
            ? 'Almost there — the server is working on it…'
            : `Uploading… ${percent}%${active > 1 ? ` (${active} files)` : ''}`}
        </span>
      </div>
    </div>
  )
}
